const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/stage',
    defaultPath: '/dashboard',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    outlinedFilled: true,
    theme: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    i18n: 'en',
    rtlLayout: false,
    jwt: {
        secret: 'SECRET-KEY',
        timeout: '1 days'
    },
    firebase: {
        apiKey: 'AIzaSyDJqwX45dWmbVFJNd1CmdQN3sGrWjdQLYw',
        authDomain: 'viz-builder.firebaseapp.com',
        projectId: 'viz-builder',
        storageBucket: 'viz-builder.appspot.com',
        messagingSenderId: '416740673477',
        appId: '1:416740673477:web:b6db3710c9c28c595badac',
        measurementId: 'G-L8SZNV27V5'
    },
    auth0: {
        client_id: 'HvYn25WaEHb7v5PBT7cTYe98XATStX3r',
        domain: 'demo-localhost.us.auth0.com'
    }
};

export default config;
